"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var actions = __importStar(require("./signUpActions"));
var defaultState = {
    signUpStatus: 'initial',
    signUpMessage: '',
    userId: ''
};
function reducer(state, action) {
    if (state === void 0) { state = defaultState; }
    var payload = action.payload;
    switch (action.type) {
        case actions.signUp.TRIGGER: {
            return __assign(__assign({}, state), { signUpStatus: 'loading' });
        }
        case actions.signUp.SUCCESS: {
            var user_id = payload.user_id;
            return __assign(__assign({}, state), { userId: user_id, signUpStatus: 'activation_key', signUpMessage: payload.message });
        }
        case actions.signUp.FAILURE: {
            return __assign(__assign({}, state), { signUpStatus: 'initial', signUpMessage: payload.data.message });
        }
        case actions.activateUser.TRIGGER: {
            return __assign(__assign({}, state), { signUpStatus: 'loading' });
        }
        case actions.activateUser.SUCCESS: {
            return __assign(__assign({}, state), { signUpStatus: 'success' });
        }
        case actions.activateUser.FAILURE: {
            return __assign(__assign({}, state), { signUpStatus: 'activation_key' });
        }
        default:
            return state;
    }
}
exports.default = reducer;
